import { FileUploadPicker } from "components/FileUploadPicker"
import { AppPrimaryButton, FormCheckBoxField, RTEFormField } from "elements"
import { useEffect, useState } from "react"
import { Form } from "semantic-ui-react"
import { AcceptFileType, FormErrorText, MediaService } from "utility"
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { FlexRow } from "components"

const SettingSchema = yup.object().shape({
    Answer: yup.string().trim(FormErrorText.SpacesNotAllowed).strict(),
    IncludeInTableContent: yup.boolean(),
    ShowHeader: yup.boolean(),
    ShowFooter: yup.boolean(),

})
export const ReportAboutus = ({ data, onSubmit }) => {
    const [files, setFiles] = useState([])
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({ resolver: yupResolver(SettingSchema) })

    useEffect(() => {
        if (!data) {
            reset({ Answer: "", IncludeInTableContent: false })
            setFiles([])
        } else {
            reset({ ...data })
            if (data?.BackGroundImage) {
                setFiles([{ url: data?.BackGroundImage, preview: false }])
            } else {
                setFiles([])
            }
        }
    }, [data])

    const submit = async (formData) => {
        let url = ""
        if (files?.length) {
            try {
                if (!files[0].preview) {
                    const result = await MediaService.uploadMedia({ media: files[0].file })
                    url = result.ImagePathUrl
                } else {
                    url = files[0].url
                }
            } catch (error) {
                console.log("error:", error)
            }
        }
        onSubmit({ ...formData, BackGroundImage: url })
    }

    return <Form>
        <Form.Field className="mt-2">
            <RTEFormField control={control} name="Answer" errors={errors.Text} />
        </Form.Field>
        <Form.Field className="mt-2">
            <div className="col-12">
                <FileUploadPicker
                    maxFiles={1}
                    label="BackGround Image"
                    maxFileSize={500}
                    accept={AcceptFileType.image}
                    addedNewFiles={(file) => setFiles(file)}
                    files={files || []}
                    fullview
                />
            </div>
            <Form.Group widths="equal">
                <Form.Field>
                    <FormCheckBoxField
                        control={control}
                        label="Show in Table of Contents"
                        name="IncludeInTableContent"
                        errors={errors.IncludeInTableContent}
                    />
                </Form.Field>
                <Form.Field>
                    <FormCheckBoxField
                        control={control}
                        label="Show Header"
                        name="ShowHeader"
                        errors={errors.ShowHeader}
                    /></Form.Field>
                <Form.Field>
                    <FormCheckBoxField
                        control={control}
                        label=" Show Footer"
                        name="ShowFooter"
                        errors={errors.ShowFooter}
                    />
                </Form.Field>
            </Form.Group>
        </Form.Field>
        <FlexRow className="justify-content-end"><AppPrimaryButton onClick={handleSubmit(submit)}>Submit</AppPrimaryButton></FlexRow>
    </Form>
}

export const UploadBox = ({ title, onSubmit, data }) => {
    const [files, setFiles] = useState([])

    useEffect(() => {
        if (data?.Answer) {
            setFiles([{ url: data?.Answer, preview: false }])
        }
    }, [data])

    const submit = async (formData) => {
        let url = ""
        if (files?.length) {
            try {
                if (!files[0].preview) {
                    const result = await MediaService.uploadMedia({ media: files[0].file })
                    url = result.ImagePathUrl
                } else {
                    url = files[0].url
                }
            } catch (error) {
                console.log("error:", error)
            }
        }
        onSubmit({ ...formData, Answer: url })
    }
    return (
        <>
            <Form>
                <Form.Field>
                    <label>{title} Title</label>
                    <div className="col-12">
                        <FileUploadPicker
                            maxFiles={1}
                            label={title}
                            maxFileSize={500}
                            accept={AcceptFileType.image}
                            addedNewFiles={(file) => setFiles(file)}
                            files={files || []}
                            fullview
                        />
                    </div>
                </Form.Field>
                <FlexRow className="justify-content-end"><AppPrimaryButton onClick={submit}>Submit</AppPrimaryButton></FlexRow>
            </Form>
        </>)
}